import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { fetchDefault } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import HowPayDialog from './seat/HowPayDialog';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";


const useStyles = makeStyles(theme => ({
    textField: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(1),
        width: 200,
    },
    menu: {
        width: 180,
    },
    menuButton: {
        margin: theme.spacing(0.5),
        fontSize: 15,
    },
    table: {
        minWidth: 100
    },
}));

const theme = createMuiTheme({
    overrides: {
        MuiTableCell: {
            root: {
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 2,
                paddingRight: 2
            }
        }
    }
});

export default function History() {
    const classes = useStyles();
    let history = useHistory();

    const [payHistoryList, setPayHistoryList] = React.useState();
    const [seatHistoryList, setSeatHistoryList] = React.useState();
    const [monthlyHistoryList, setMonthlyHistoryList] = React.useState();
    const [prepaidHistoryList, setPrepaidHistoryList] = React.useState();
    const [cabinetHistoryList, setCabinetHistoryList] = React.useState();
    const [snackHistoryList, setSnackHistoryList] = React.useState();

    useEffect(() => {

        getPayHistory();


        return () => {
        }
    }, []);

    const getPayHistory = () => {
        fetchDefault('/Payment/GetPayHistory',
            (data) => {
                setPayHistoryList(data);
                setSeatHistoryList();
                setMonthlyHistoryList();
                setPrepaidHistoryList();
                setCabinetHistoryList();
                setSnackHistoryList();
            }
        );
    };

    const getSeatHistory = () => {
        fetchDefault('/Payment/GetSeatHistory',
            (data) => {
                setPayHistoryList();
                setSeatHistoryList(data);
                setMonthlyHistoryList();
                setPrepaidHistoryList();
                setCabinetHistoryList();
                setSnackHistoryList();
            }
        );
    };

    const getMonthlyHistory = () => {
        fetchDefault('/Payment/GetMonthlyHistory',
            (data) => {
                setPayHistoryList();
                setSeatHistoryList();
                setMonthlyHistoryList(data);
                setPrepaidHistoryList();
                setCabinetHistoryList();
                setSnackHistoryList();
            }
        );
    };

    const getPrepaidHistory = () => {
        fetchDefault('/Payment/GetPrepaidHistory',
            (data) => {
                setPayHistoryList();
                setSeatHistoryList();
                setMonthlyHistoryList();
                setPrepaidHistoryList(data);
                setCabinetHistoryList();
                setSnackHistoryList();
            }
        );
    };

    const getCabinetHistory = () => {
        fetchDefault('/Payment/GetCabinetHistory',
            (data) => {
                setPayHistoryList();
                setSeatHistoryList();
                setMonthlyHistoryList();
                setPrepaidHistoryList();
                setCabinetHistoryList(data);
                setSnackHistoryList();
            }
        );
    };

    const getSnackHistory = () => {
        fetchDefault('/Payment/GetSnackHistory',
            (data) => {
                setPayHistoryList();
                setSeatHistoryList();
                setMonthlyHistoryList();
                setPrepaidHistoryList();
                setCabinetHistoryList();
                setSnackHistoryList(data);
            }
        );
    };



    return (
        <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>이용내역</h2>
                </Grid>

                <Grid item xs={12}>
                    <Button variant="outlined" onClick={() => getPayHistory()} className={classes.menuButton}>
                        결제
                    </Button>
                    <Button variant="outlined" onClick={() => getSeatHistory()} className={classes.menuButton}>
                        자리이용
                    </Button>
                    <Button variant="outlined" onClick={() => getMonthlyHistory()} className={classes.menuButton}>
                            월정액
                    </Button>
                    <Button variant="outlined" onClick={() => getPrepaidHistory()} className={classes.menuButton}>
                            시간정액권
                    </Button>
                    <Button variant="outlined" onClick={() => getCabinetHistory()} className={classes.menuButton}>
                        사물함
                    </Button>
                    <Button variant="outlined" onClick={() => getSnackHistory()} className={classes.menuButton}>
                        스낵/음료
                    </Button>
                </Grid>

                {!payHistoryList && !seatHistoryList && !monthlyHistoryList && !cabinetHistoryList && !snackHistoryList && !prepaidHistoryList ? (<Grid>내역이 없습니다.</Grid>) : (<Grid></Grid>)}


                {payHistoryList ? (
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">결제날짜</TableCell>
                                    <TableCell align="center">내용</TableCell>
                                    <TableCell align="center">충전금액</TableCell>
                                    <TableCell align="center">충전 전 잔액</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {payHistoryList.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell align="center" component="th" scope="row">
                                            {row.registDateTime}
                                        </TableCell>
                                        <TableCell align="center">{row.howPaid}</TableCell>
                                        <TableCell align="center">{row.chargeMoney}</TableCell>
                                        <TableCell align="center">{row.beforeMoney}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (<Grid></Grid>)}

                {seatHistoryList ? (
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">자리</TableCell>
                                    <TableCell align="center">시작시간</TableCell>
                                    <TableCell align="center">종료시간</TableCell>
                                    <TableCell align="center">사용금액</TableCell>
                                    <TableCell align="center">정액권사용</TableCell>
                                    <TableCell align="center">결제날짜</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {seatHistoryList.map((row) => (
                                    <TableRow key={row.id}>    
                                        <TableCell align="center">{row.tableManageName}</TableCell>
                                        <TableCell align="center">{row.startDateTime}</TableCell>
                                        <TableCell align="center">{row.endDateTime}</TableCell>
                                        <TableCell align="center">{row.spendMoney}</TableCell>
                                        <TableCell align="center">{row.prepaidTime}</TableCell>
                                        <TableCell align="center">{row.payDateTime}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    ) : (<Grid></Grid>)}


                    {monthlyHistoryList ? (
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">시작날짜</TableCell>
                                        <TableCell align="center">종료날짜</TableCell>
                                        <TableCell align="center">사용금액</TableCell>
                                        <TableCell align="center">결제날짜</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {monthlyHistoryList.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.startDateTime}</TableCell>
                                            <TableCell align="center">{row.endDateTime}</TableCell>
                                            <TableCell align="center">{row.spendMoney}</TableCell>
                                            <TableCell align="center">{row.payDateTime}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (<Grid></Grid>)}


                    {prepaidHistoryList ? (
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">결제날짜</TableCell>
                                        <TableCell align="center">충전시간</TableCell>
                                        <TableCell align="center">사용금액</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {prepaidHistoryList.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.payDateTime}</TableCell>
                                            <TableCell align="center">{row.prepaidTime}</TableCell>
                                            <TableCell align="center">{row.spendMoney}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (<Grid></Grid>)}


                    {cabinetHistoryList ? (
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">번호</TableCell>
                                        <TableCell align="center">시작날짜</TableCell>
                                        <TableCell align="center">종료날짜</TableCell>
                                        <TableCell align="center">사용금액</TableCell>
                                        <TableCell align="center">결제날짜</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {cabinetHistoryList.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.number}</TableCell>
                                            <TableCell align="center">{row.startDateTime}</TableCell>
                                            <TableCell align="center">{row.endDateTime}</TableCell>
                                            <TableCell align="center">{row.spendMoney}</TableCell>
                                            <TableCell align="center">{row.payDateTime}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (<Grid></Grid>)}

                    {snackHistoryList ? (
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">결제날짜</TableCell>
                                        <TableCell align="center">개수</TableCell>
                                        <TableCell align="center">사용금액</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {snackHistoryList.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center" component="th" scope="row">
                                                {row.payDateTime}
                                            </TableCell>
                                            <TableCell align="center">{row.amount}</TableCell>
                                            <TableCell align="center">{row.spendMoney}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (<Grid></Grid>)}
            </Grid>

            </div>
        </MuiThemeProvider>
    );

}



// WEBPACK FOOTER //
// ./src/components/History.js